import React from 'react'
import {CheckCircleFilled} from "@ant-design/icons";

interface Props {}

const FunctionCard = ({icon, title, desc}) => {

  return (
    <>
        <div className="card border-0">
            <div className="card-body p-6">
                <div className={"flex flex-row gap-2 items-start"}>
                    {icon}
                    <div>
                        <div className={"flex flex-row gap-2"}>
                            <p className=" text-sm">{title}</p>
                        </div>
                        <p className={"text-md text-[#4B5563]"}>{desc}</p>
                    </div>
                </div>

            </div>
        </div>
    </>
  )
}

export default FunctionCard;
